import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'País del banco'},//0
    {title: 'Código bancario'},//1    
    {title: 'Nombre del banco'},//2
];


class BankModal extends Component {
    componentDidMount(): void {
        this.closeAction();
    }
    closeAddress = async () => {
        $('#bankModal').modal('hide');
    }

    closeAction = () => {
        $('#bankModal').on('hidden.bs.modal', function () {
        });
    };

    render() {
        const {data,action} = this.props;
        return (
            <div>
                <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="bankModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Lista de Bancos</h4>
                                <button type="button" className="close" onClick={this.closeAddress} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="table-wrapper-scroll-y my-custom-scrollbar " aria-labelledby="nav-home-tab-Contenido" >
                                                <table id="tablaBanks" className="table table-bordered table-striped mb-0" style={{marginBottom: 0}}>
                                                <thead className="table-header-yellow">
                                                        <tr style={{textAlign: "center"}}>
                                                            <td className=" sticky-column sticky-header" 
                                                                style={{maxWidth:300, backgroundColor: '#d2ab24'}}/> 

                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                País del banco
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Código bancario
                                                            </td>
                                                            <td className="sticky-header" style={{backgroundColor: '#d2ab24'}}>
                                                                Nombre del banco
                                                            </td>
                                                           
                                                        </tr>
                                                    </thead>
                                                    
                                                    <tbody>
                                                        {data.map((register, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td style={{textAlign:"center", width:100}}>
                                                                        <button type="button" className="btn btn-sm "
                                                                                onClick={()=>action(register)}
                                                                                style={{fontWeight: '500', backgroundColor: "transparent", color: "#EABF28"}}>
                                                                            <i className="fas fa-check"></i>
                                                                        </button>
                                                                    </td>

                                                                    <td>{register.Name || ""}</td>
                                                                    <td>{(register.BankCode || '')}</td>
                                                                    <td>{(register.BankName || '')}</td> 
                                                                    
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                              
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeAddress}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BankModal;